var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.2525 10C1.415 4.3025 6.465 0 12.5 0H47.5C53.535 0 58.585 4.3025 59.7475 10H0.2525ZM60 15V47.5C60 54.3925 54.3925 60 47.5 60H12.5C5.6075 60 0 54.3925 0 47.5V15H60ZM7.5 25C7.5 26.38 8.6175 27.5 10 27.5H22.5C23.8825 27.5 25 26.38 25 25C25 23.62 23.8825 22.5 22.5 22.5H10C8.6175 22.5 7.5 23.62 7.5 25ZM37.5 50C37.5 48.6175 36.3825 47.5 35 47.5H10C8.6175 47.5 7.5 48.6175 7.5 50C7.5 51.3825 8.6175 52.5 10 52.5H35C36.3825 52.5 37.5 51.3825 37.5 50ZM37.5 37.5C37.5 36.1175 36.3825 35 35 35H17.5C16.1175 35 15 36.1175 15 37.5C15 38.8825 16.1175 40 17.5 40H35C36.3825 40 37.5 38.8825 37.5 37.5ZM52.5 50C52.5 48.155 51.4875 46.56 50 45.6925V30C50 25.865 46.635 22.5 42.5 22.5H39.3075C38.4425 21.0125 36.8475 20 35 20C32.2375 20 30 22.2375 30 25C30 27.7625 32.2375 30 35 30C36.845 30 38.44 28.9875 39.3075 27.5H42.5C43.88 27.5 45 28.6225 45 30V45.6925C43.5125 46.5575 42.5 48.1525 42.5 50C42.5 52.7625 44.7375 55 47.5 55C50.2625 55 52.5 52.7625 52.5 50Z",
    fill: "#548054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.abf9ad234512b78750534b1a72f7256b.svg";
export { ForwardRef as ReactComponent };